<div class="ui-modal add-person-to-group-dialog">
  <div class="header flex-row space-between-center">
    <div>{{ 'PERSON_GROUPS.ADD_PERSONS_DIALOG.TITLE' | translate: { name: data.groupName } }}</div>
    <span class="ui-icon-close c-p" tabindex="0" role="button" (click)="onClose()" (keydown.enter)="onClose()"></span>
  </div>

  <div class="body flex-col flex-1 min-h-0 gap-16">
    <div class="dialog-tabs">
      <app-database-tabs
        [tabs]="dialogTabs"
        [activeTab]="currentTab()"
        (activeTabChange)="changeActiveTab($event)"
      ></app-database-tabs>
    </div>

    @if (currentTab() === tabs.SavedPersons) {
      <ui-search
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
        [placeholder]="searchPlaceholderKey | translate"
      ></ui-search>
    }

    <div class="dialog-content">
      @switch (currentTab()) {
        @case (tabs.SavedPersons) {
          @if (isSavedPersonsLoading()) {
            <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
          } @else {
            @switch (savedPersonsViewState()) {
              @case (viewState.HAS_CONTENT) {
                <div class="persons-grid">
                  @for (person of filteredSavedPersons(); track person.personId) {
                    <ui-person-tile
                      [ngModel]="isSavedPersonSelected(person.personId)"
                      (ngModelChange)="updateSavedPersonSelection(person.personId, $event)"
                      [disabled]="isPersonExistedInGroup(person.personId)"
                      [label]="person.name || '-'"
                      [imageUrl]="getImagePath(person)"
                      [imageUrlFallback]="getImagePath(person, false)"
                      [showConfirmationStatus]="true"
                      [isConfirmed]="person.trainingStatus === personTrainingStatus.Trained"
                    ></ui-person-tile>
                  }
                </div>
              }
              @case (viewState.NO_RESULTS) {
                <ui-no-data
                  [imgSrc]="personNoData.noResults.imgSrc"
                  [title]="personNoData.noResults.title | translate"
                ></ui-no-data>
              }
              @case (viewState.INITIAL_EMPTY) {
                <ui-no-data
                  [imgSrc]="personNoData.noSaved.imgSrc"
                  [title]="personNoData.noSaved.title | translate"
                ></ui-no-data>
              }
            }
          }
        }
        @case (tabs.UnsavedPersons) {
          @if (isUnsavedPersonsLoading()) {
            <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
          } @else {
            @switch (unsavedPersonsViewState()) {
              @case (viewState.HAS_CONTENT) {
                <div class="persons-grid">
                  @for (person of filteredUnsavedPersons(); track person.bucketId) {
                    <ui-person-tile
                      [ngModel]="isUnsavedPersonSelected(person.bucketId)"
                      (ngModelChange)="updateUnsavedPersonSelection(person.bucketId, $event)"
                      [label]="getUnsavedPersonLabel(person.appearances)"
                      [imageUrl]="getImagePath(person)"
                      [imageUrlFallback]="getImagePath(person, false)"
                      [showConfirmationStatus]="false"
                    ></ui-person-tile>
                  }
                </div>
              }
              @case (viewState.NO_RESULTS) {
                <ui-no-data
                  [imgSrc]="personNoData.noResults.imgSrc"
                  [title]="personNoData.noResults.title | translate"
                ></ui-no-data>
              }
              @case (viewState.INITIAL_EMPTY) {
                <ui-no-data
                  [imgSrc]="personNoData.noUnsaved.imgSrc"
                  [title]="personNoData.noUnsaved.title | translate"
                ></ui-no-data>
              }
            }
          }
        }
      }
    </div>
  </div>

  <div class="footer flex-row space-between-center">
    <span class="add-person-to-group-dialog-selection">
      @if (selectedItemsCount() > 0) {
        {{ 'PERSON_GROUPS.ADD_PERSONS_DIALOG.SELECTED_COUNT' | translate: { count: selectedItemsCount() } }}
      } @else {
        {{ 'PERSON_GROUPS.ADD_PERSONS_DIALOG.NO_ITEMS_SELECTED' | translate }}
      }
    </span>
    <div class="flex-row gap-8">
      <ui-button type="secondary" [text]="'COMMON.CANCEL' | translate" (clickAction)="onClose()"></ui-button>
      <ui-button
        type="primary"
        [disabled]="addSelectedDisabled()"
        [loading]="isAddingPersonsToGroups()"
        [text]="'PERSON_GROUPS.ADD_PERSONS_DIALOG.ADD_SELECTED' | translate"
        (clickAction)="onAddSelected()">
      </ui-button>
    </div>
  </div>
</div>
